module.exports = __webpack_public_path__ + "img/upload.c9663661.svg";